import { DOMAIN, baseURL } from "constants/common";
import { ChartData, ChartQuery } from "src/containers/chart/types";
import { apiHelper } from "src/utils/apiHelpers";
import { CreateItineraryQuery } from "./types";
import { ItineraryData } from "src/containers/itinerary/types";

export const getSeatChart = (query: ChartQuery, opName: string | undefined) => {
  let URL = `${DOMAIN}/api/bus/v1/chart`;
  if (opName) URL += `?operatorName=${opName}`;

  return apiHelper<ChartData>(
    URL,
    "POST",
    { ...query },
    `application/json`,
    {}
  );
};

export const createItinerary = (
  query: CreateItineraryQuery,
  headers: Record<string, string> = {}
) => {
  const URL = `${DOMAIN}/api/bus/v1/itin`;

  return apiHelper(URL, "POST", { ...query }, `application/json`, headers);
};

export const getTravellers = (itineraryId: string) => {
  const URL = `${baseURL}/itin/travellers?itineraryId=${itineraryId}`;
  return apiHelper(URL, "GET");
};

export const updateTravellers = (
  payload: ItineraryData,
  header: Record<string, string> | undefined = undefined
) => {
  const URL = `${baseURL}/itin/travellers`;
  return apiHelper(URL, "PUT", payload, undefined, header);
};
